//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.FeatureBuilder.js";
let d=[[[0,"Tool",1,"NXObject",0],[0,"TrimDirection",1,0]],[[["num_bodies"],"GetTargets",{R_:{target:"Body[]"}},0,0],[["target"],"SetTargets",{},1,0],[["target"],"AddTarget",{},1,0],[["target"],"RemoveTarget",{},1,0],[[],"Reverse",{},0,0]],[]];
SPLM.Features.TrimBodyBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.TrimBodyBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.TrimBodyBuilder.DirectionType = Object.freeze({
    "PositiveNormal" : "PositiveNormal", "NegativeNormal" : "NegativeNormal", "Invalid" : "Invalid"});

export default SPLM;